import { useSelector } from 'react-redux';
import useRouter from './useRouter';
import { selectUser } from '../reducers/user.selectors';
import isCoursePage from './isCoursePage';
import { useNewDesign } from '../state/DesignPreferenceContextProvider';
import { userType } from '../constants';

export const useNewNavigation = () => {
  const { match: { location: { pathname, query } } } = useRouter();
  const user = useSelector(selectUser);
  const { prefersNewDesign } = useNewDesign();

  if (query && query['newNavigation'] === 'true') {
    return true;
  } else if (user?.type === userType.basis) {  // For user type 1
    return false;
  } else if (user?.type === userType.courses) {  // For user type 3
    return isCoursePage(pathname); 
  } else { // For user types 2 and 4
    return prefersNewDesign;
  }
};
